import React from "react";
import { useLoadScopes } from "./auth";
import { getPermissions } from "./getPageTitle";
import { Location } from "react-router-dom";

export function useGetPermissions(
  requestedPermissions: string[],
  location?: Location | string,
  overridePermissionsPathName?: string
) {
  const scopes = useLoadScopes();

  let pathname: string;
  if (typeof location === "string") {
    pathname = location;
  } else if (overridePermissionsPathName) {
    pathname = overridePermissionsPathName;
  } else {
    pathname = location?.pathname ?? "";
  }
  const permissions = React.useMemo(() => {
    return getPermissions(requestedPermissions, pathname.slice(1), scopes);
  }, [requestedPermissions, pathname, scopes]);

  if (pathname === "/projectmanagement") {
    let editPermission = scopes
      .find(scope => scope.path === "projects")
      ?.childElements?.find(element => element.path === "projects/edit");
    let viewSitePermission = scopes
      .find(scope => scope.path === "sites")
      ?.childElements?.find(element => element.path === "sites/view");
    if (editPermission) {
      permissions.set("edit", true);
    }
    if (viewSitePermission) {
      permissions.set("sites-view", true);
    }
  }

  return permissions;
}
